<template>
  <AppSkeletonTable v-show="loadingList"></AppSkeletonTable>
  <TreeTable
    v-show="!loadingList"
    :value="results"
    responsiveLayout="stack"
    :lazy="true"
  >
    <Column
      header="Nome"
      field="name"
      headerStyle="width: 100px"
      :sortable="true"
      :expander="true"
    >
      <template #body="props">
        <ServiceType
          style="display: inline"
          :value="props.node.data.name"
          :background="props.node.data.color || 'gray'"
        ></ServiceType>
      </template>
    </Column>
    <Column
      header="Descrição"
      field="description"
      headerStyle="width: 100px"
      :sortable="true"
    >
      <template #body="props">
        {{ props.node?.data?.description || '-' }}
      </template>
    </Column>
    <Column header="Ações" headerStyle="width: 50px">
      <template #body="props">
        <Button
          type="button"
          icon="pi pi-plus"
          class="p-button-text p-button-secondary"
          :disabled="!$ability.can('write', 'Service')"
          @click="$emit('create-subtype', props.node.data)"
        ></Button>
        <Button
          type="button"
          icon="pi pi-trash"
          class="p-button-text p-button-secondary"
          :disabled="!$ability.can('delete', 'Service')"
          @click="openDeleteConfirm(props.node)"
        ></Button>
      </template>
    </Column>
  </TreeTable>
  <Paginator
    :rows="query.pageSize"
    :totalRecords="pagination.total"
    @page="onChangePage({ page: $event.page + 1 })"
  ></Paginator>
  <AppModalDelete
    type="Tipo de Serviço"
    :visible="deleteConfirm.visible"
    :item="deleteConfirm.item"
    @confirm="confirmDelete()"
    @cancel="hideDeleteConfirm()"
  ></AppModalDelete>
</template>

<script>
import TreeTable from 'primevue/treetable';
import { ServiceTypeApi } from '../../../services/api';
import ServiceType from './ServiceType.vue';

export default {
  name: 'ServiceTypeList',
  components: {
    ServiceType,
    TreeTable,
  },
  async created() {
    await this.fetchList();
  },
  emits: ['create-subtype'],
  data() {
    return {
      results: [],
      loadingList: false,
      query: {
        root: true,
        page: 1,
        pageSize: 20,
        order: 'desc',
        orderField: 'id',
      },
      pagination: {
        total: 0,
        current: 1,
        pages: 1,
      },
      deleteConfirm: {
        id: null,
        visible: false,
        item: '',
      },
    };
  },
  methods: {
    async fetchList() {
      try {
        this.loadingList = true;
        const fetchResponse = await ServiceTypeApi.fetch(this.query);
        this.results = this.formatResults(fetchResponse.results);
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingList = false;
      }
    },
    hideDeleteConfirm() {
      this.deleteConfirm = { id: null, visible: false, item: '' };
    },
    openDeleteConfirm(event) {
      this.deleteConfirm = {
        id: event.key,
        visible: true,
        item: event.data.name,
      };
    },
    async confirmDelete() {
      await ServiceTypeApi.delete(this.deleteConfirm.id);
      this.hideDeleteConfirm();
      this.fetchList();
    },
    formatResults(results) {
      return results.map((result) => ({
        key: result.id,
        data: result,
        children: this.formatResults(result.children),
        leaf: !result.children.length,
      }));
    },
    async onChangePage(event) {
      this.query.page = event.page;
      await this.fetchList();
    },
  },
};
</script>

<style>
</style>
